export const incrementDecrement = (condictional: boolean, value: number) =>
  condictional ? value + 1 : value - 1
